export const TITLE = 'Basic information';
export const DESCRIPTION = 'Profile photo, title, gender ...';
export const DB_PREFIX = 'info';
